
import {
  defineComponent, onBeforeMount, reactive,
} from 'vue';
import { useAppBase } from '@/core/composables/AppBase';
import ComunicacaoApi from '@/core/components/UI/ComunicacaoApi.vue';
import IndicadorNumero from '@/core/components/UI/IndicadorNumero.vue';
import { IDTODashboard } from '@/models/DTO/IDTODashboard';
import storeApp from '@/store/storeApp';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import router from '@/router';
import OcorrenciasMapa from '@/components/OcorrenciasMapa.vue';

export default defineComponent({
  name: 'Dashboard',
  components: {
    ComunicacaoApi,
    IndicadorNumero,
    OcorrenciasMapa,
  },
  setup() {
    const {
      appBase,
    } = useAppBase();
    const state = reactive({
      dashboard: {} as IDTODashboard,
      privilegios: [] as string[],
    });

    function limparDados() {
      state.dashboard.codigoEleicao = 0;
      state.dashboard.nomeEleicao = '';
      state.dashboard.quantidadeAfiliados = 0;
      state.dashboard.afialiadosQueVotaram = 0;
      state.dashboard.quantidadeSecoes = 0;
      state.dashboard.atasRegistradas = 0;
      state.dashboard.percentualApuracaoVotos = 0;
    }

    function apresentarApuracao() : boolean {
      if (UtilitarioGeral.validaLista(state.privilegios)) {
        return state.privilegios.some((c) => c === 'APURACAO');
      }
      return false;
    }

    onBeforeMount(async () => {
      limparDados();
      appBase.carregando = true;
      state.privilegios = storeApp.state.usuarioAutenticado.privilegios.map((c) => c.privilegio);

      if (state.privilegios.length === 1) {
        if (state.privilegios.some((c) => c === 'REGISTRAR_PRESENCA_VOTACAO')) {
          router.push({ name: 'EleicaoLiberarVotacao' });
          appBase.carregando = false;
          return;
        }
      }
      appBase.carregando = false;
    });

    return {
      appBase,
      state,
      storeApp,
      UtilitarioGeral,
      UtilitarioMascara,
      apresentarApuracao,
    };
  },
});
